<script setup lang="ts">
definePageMeta({
  layout: 'default',
})
</script>
<template>
  <div>
    <Contact />
  </div>
</template>
